import React, {useMemo} from 'react'
import { useWindowDimensions } from '@Knowledge-OTP/znk-ui-components'
import useCalendar from '../../Calendar/Sections/Calendar/useCalendar'
import {NameField, DateField, StudentField, StatusField, OptionsField, EducatorField} from './Fields'
import moment from 'moment'

const useColumns = (refetch = () => {}) => {
    const {breakWidth} = useWindowDimensions()
    const {getLessonStatus} = useCalendar()
    return useMemo(
        () => {
            let config = [{col: 3, className: 'text-truncate'},{col: 2, className: 'text-truncate'},{col: 2},{col: 2},{col: 2},{col: 1}]
            if(breakWidth === 'SM') {
                config = [{col: 6, className: 'text-truncate'}, {col: 4}, {col: 2}]
            } else if (breakWidth === 'MD') {
                config = [{col: 4, className: 'text-truncate'}, {col: 3}, {col: 3}, {col: 2}]
            }
            return {
                config,
                variant: breakWidth === 'SM' ? 'card' : 'row',
                generateRow: (lesson, upcommingLessons = []) => {
                    const {status} = getLessonStatus(lesson)
                    const inProgress = moment() > moment(lesson?.startDate) && moment() < moment(lesson?.endDate)
                    //scheduled, incomplete, finished, draft, upcoming, attended, missed
                    let rowInner = [
                            <NameField className={`d-flex flex-row justify-content-start`} lesson={lesson}/>,
                            <DateField lesson={lesson}/>,
                            <StudentField className={`d-flex flex-row justify-content-start align-items-center text-truncate znk-scroll-horizontal-v2`} lesson={lesson}/>,
                            <EducatorField className={`d-flex flex-row justify-content-start align-items-center text-truncate`} lesson={lesson}/>,
                            <StatusField className={`d-flex flex-row justify-content-end align-items-center`} realStatus={status} lesson={lesson}/>,
                            <OptionsField className={`d-flex flex-row justify-content-end`} lesson={lesson} refetch={refetch}/>,
                        ]
                    if(breakWidth === 'SM') {
                        // Mobile card (design system): two lines rendered by TableTask variant='card'.
                        rowInner = [
                            <div className='lesson-card-line lesson-card-top'>
                                <NameField className='lesson-card-name' lesson={lesson}/>
                                <DateField className='lesson-card-time' format='hh:mm a' lesson={lesson}/>
                            </div>,
                            <div className='lesson-card-line lesson-card-bottom'>
                                <StudentField className='lesson-card-person' lesson={lesson}/>
                                <EducatorField className='lesson-card-person' lesson={lesson}/>
                                <span className='flex-grow-1'/>
                                <StatusField className='lesson-card-status' realStatus={status} lesson={lesson}/>
                            </div>,
                        ]
                    } else if(breakWidth === 'MD') {
                        rowInner = [
                            <NameField className={`d-flex flex-row justify-content-start`} lesson={lesson}/>,
                            <EducatorField className={`d-flex flex-row justify-content-start align-items-center text-truncate`} lesson={lesson}/>,
                            <StatusField className={`d-flex flex-row justify-content-end align-items-center`} realStatus={status} lesson={lesson}/>,
                            <OptionsField className={`d-flex flex-row justify-content-end`} lesson={lesson} refetch={refetch}/>,
                        ]
                    }
                    return {
                        rowInner,
                        item: {
                            ...lesson,
                            className: `lesson-${
                                status === 'scheduled' && 
                                (upcommingLessons.includes(lesson?.id) || inProgress) 
                                    ? 'upcoming' : status 
                            } align-items-center`
                        }
                    }
                }
            }
            //eslint-disable-next-line
        }, [breakWidth]
    )
}

export default useColumns